/*
 * Purpose: Mission sub-route panel view — operate / insights / settings
 * Last modified: 2026-06-28 | Agent
 * Completeness: 90
 */
import { useParams } from 'react-router-dom';
import { MissionPanelContent, missionPanelFromParams } from '@/components/mission/MissionPanelContent';

export function MissionSectionView() {
  const { section, panel } = useParams<{ section?: string; panel?: string }>();
  const panelId = missionPanelFromParams(section, panel);

  return (
    <div className="flex-1 min-h-0 overflow-auto">
      <MissionPanelContent panel={panelId} />
    </div>
  );
}

export default MissionSectionView;
